import { SHELL } from "../shell/shell.const";

const TESTIMONY = 'testimonio';
const TESTIMONY_INITIALIZE_REQUEST = 'nuevo-testimonio';

export const TESTIMONIES_ROUTES = {
    TESTIMONY,
    
    TESTIMONY_INITIALIZE_REQUEST,

    /** /testimonio/iniciar-soliciutd */
    ROUTE_TESTIMONY_INITIALIZE_REQUEST: `${SHELL}/${TESTIMONY}/${TESTIMONY_INITIALIZE_REQUEST}`

}